import { useFeatureManagement } from "@/composables/useFeatureManagement";

/**
 * Check if a navigation item should be enabled based on FMS features
 * Replaces legacy PlanFeatureCheck.ts with FMS-based checking
 */
export function checkNavigationAccess(translationKey: string): boolean {
  const { isFeatureEnabled } = useFeatureManagement();

  switch (translationKey) {
    case "navbar.monitor.search":
    case "common.mentions":
    case "navbar.monitor.chartAnalytics":
    case "common.topics":
    case "common.reports":
    case "common.manage":
    case "navbar.manage.manageSearch":
      return isFeatureEnabled("searchProfiles");

    case "navbar.manage.targetMediaLists":
      return isFeatureEnabled("targetMediaLists");

    case "navbar.manage.emailDigests":
      return isFeatureEnabled("emailDigests");

    case "navbar.contacts.emailCampaigns":
      // eslint-disable-next-line no-console
      console.warn("[DEPRECATED] Email campaigns feature is deprecated");
      return false;

    case "navbar.monitor.authorsAndPublications":
      // eslint-disable-next-line no-console
      console.warn("[DEPRECATED] Author intelligence feature is deprecated");
      return false;

    case "navbar.contacts.myContacts":
      return isFeatureEnabled("prmAccess");

    case "common.alerts": {
      const hasEmailAlerts = isFeatureEnabled("emailAlerts");
      return hasEmailAlerts;
    }

    default:
      // eslint-disable-next-line no-console
      console.warn(
        `[FeatureNavigationCheck] Unknown navigation key: ${translationKey}`,
      );
      return false;
  }
}

/**
 * @deprecated Use checkNavigationAccess() instead
 */
export function checkPlan(_org: string, translationKey: string): boolean {
  // eslint-disable-next-line no-console
  console.warn(
    "[DEPRECATED] checkPlan() is deprecated. Use checkNavigationAccess() instead.",
  );
  return checkNavigationAccess(translationKey);
}
